import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
	selectShowBannerTermsAndCondition,
	selectBannerTermsAndConditionText,
	selectLicense,
	selectSiteCode
} from '~/components/brand/ducks/selectors.js';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import DefaultTerms from './default-terms.js';
import OntarioTerms from './ontario-terms.js';

const useBannerTermsConditions = () => {
	const shouldShowTermsConditions = useSelector(selectShowBannerTermsAndCondition);
	const termsConditionsText = useSelector(selectBannerTermsAndConditionText);
	const isAuthenticated = useSelector(authenticationSelector);
	const smaller = useSelector(state => state.browser.lessThan.medium);
	const license = useSelector(selectLicense);
	const isLicenseOGA = license === 'OGA';
	const siteCode = useSelector(selectSiteCode);
	const isComeonSite = siteCode === 'comeon';

	const isTermsConditionsEnabled =
		(isAuthenticated ? false : shouldShowTermsConditions) || (isLicenseOGA && isComeonSite);

	const termsConditions = useMemo(() => {
		if (isLicenseOGA && isComeonSite) {
			return <OntarioTerms smaller={smaller} text={termsConditionsText} />;
		}

		return <DefaultTerms text={termsConditionsText} />;
	}, [isLicenseOGA, isComeonSite, smaller, termsConditionsText]);

	return {
		isTermsConditionsEnabled,
		termsConditions
	};
};

export default useBannerTermsConditions;
